import remarkReact from './lib/index.js';
export default remarkReact;